// Helpers do totem/balcão (antes viviam no topo de pages/BalcaoVendas.js).
import { useState, useEffect } from "react";
import axios from "axios";

export const API = "/api";

// ── Fetch company logo ──
export const useCompanyLogo = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.get(`${API}/company/settings`, { headers });
        if (res.data?.logo_url) {
          const url = res.data.logo_url;
          setLogoUrl(url.startsWith("http") ? url : (url.startsWith("/") ? url : `/${url}`));
        }
      } catch (_) {}
    })();
  }, []);
  return logoUrl;
};

// ── Senha do Balcão: agora gerada server-side ──
// (antes era contador no localStorage por PC — gerava colisao entre 2 PCs no
// mesmo balcao e zerava ao limpar cache. Agora o backend usa contador atomico
// por tenant com permutacao pseudo-aleatoria — ver get_next_balcao_senha em
// database.py. Esta funcao virou fallback caso o backend nao retorne senha.)
export const fallbackSenhaFromCodigo = (codigo) => {
  if (!codigo) return "---";
  const digits = String(codigo).replace(/\D/g, '');
  return digits.slice(-3).padStart(3, "0") || "---";
};

// ── Helpers ──
export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  return url;
};
export const isPngImage = (url) => url?.toLowerCase().endsWith(".png") || false;
export const fmt = (v) => (v || 0).toFixed(2).replace(".", ",");
